import { Vue, Component } from 'vue-property-decorator'
import NewsDetail from '~/components/page/newsDetail/NewsDetail'
import s from '~/utils/s'
import SeoHelper from '~/utils/seoHelper'

@Component({
  async fetch ({ route, store }) {
    await s(store).newsDetailPage.loadData(route)
    await new SeoHelper(route.name ?? '', store).load()
  }
})
export default class extends Vue {
  render () {
    return (
      <NewsDetail />
    )
  }
}
